export default "__VITE_ASSET__oa3OZM_t__"